import {connect} from 'react-redux'
import {setReCaptchaResponse, submit} from "../actions";
import Contact from "../components/Contact";

const mapStateToProps = (state) => ({
    isFilled:      !!(state.contact.request.name &&
                      state.contact.request.phone &&
                      state.contact.request.email &&
                      state.contact.request.message),
    reCaptchaShow: !!state.contact.reCaptcha.show,
    submitWaiting: !!state.contact.submit.waiting,
    submitSuccess: !!state.contact.submit.success,
    submitFailure: !!state.contact.submit.failure
});

const mapDispatchToProps = (dispatch) => ({
    setReCaptchaResponse: (response) => dispatch(setReCaptchaResponse(response)),
    submit:               () => dispatch(submit())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Contact);



// WEBPACK FOOTER //
// ./src/app/contact/containers/Contact.js